import React, { memo } from 'react'

import SummaryWidget from './SummaryWidget'
import BalanceCountDown from '../shared/overview/BalanceCountDown'

import balanceIcon from 'assets/balance-icon.png'

const PointsSummary = ({
  t,
  symbol,
  mainProfile: { previousUserPoints, currentUserPoints }
}) => {
  return (
    <SummaryWidget
      title={t('home.symbol-balance', { symbol })}
      value={
        <BalanceCountDown
          prev={previousUserPoints}
          current={currentUserPoints}
        />
      }
      icon={balanceIcon}
    />
  )
}

export default memo(PointsSummary)
